<template>
  <footer class="bg-dark-grey">
    <div class="container">
      <div class="footer-wrapper">
        <div class="footer-menu">
          <div class="footer-link footer-link-bold">
            <a :href="`${revampWebURL}/about-us`">{{ $t("about_paxel") }}</a>
          </div>
          <div class="footer-link footer-link-bold">
            <a :href="`${revampWebURL}/our-service`">{{ $t("our_services") }}</a>
          </div>
          <div class="footer-link footer-link-bold">
            <a :href="`${revampWebURL}/news-and-promos`">{{ $t("news_and_promos") }}</a>
          </div>
          <div class="footer-link footer-link-bold">
            <a :href="`${revampWebURL}/antarkan-kebaikan`">#AntarkanKebaikan</a>
          </div>
        </div>
        <div class="footer-menu">
          <div class="footer-link footer-link-bold">
            <a :href="`${revampWebURL}/partnership`">{{ $t("partnership_about") }}</a>
          </div>
          <div class="footer-link">
            <a :href="paxelCorporate">Corporate</a>
          </div>
          <div class="footer-link">
            <a :href="`${revampWebBaseURL}/mitrapaxel`">Mitra PaxelCo</a>
          </div>
          <div class="footer-link">
            <a :href="paxelBigURL">PaxelBig</a>
          </div>
          <div class="footer-link">
            <a :href="`${paxelBoxURL}`">PaxelBox</a>
          </div>
        </div>
        <div class="footer-menu">
          <div class="footer-link footer-link-bold">
            <a :href="`${revampWebURL}/help-and-support`">{{ $t("support") }}</a>
          </div>
          <div class="footer-link">
            <a :href="`${paxelCekOngkir}`">{{ $t('track_ongkir') }}</a>
          </div>
          <div class="footer-link">
            <a :href="`${paxelCekResi}`">{{ $t('track_your_shipment') }}</a>
          </div>
        </div>
        <div class="footer-menu">
          <div class="footer-link footer-link-bold">
            <a :href="`${revampWebURL}/terms-and-conditions`">{{ $t("terms_and_conditions") }}</a>
          </div>
          <div class="footer-link footer-link">
            <a :href="`${revampWebURL}/privacy-policy`">{{ $t("privacy_policy") }}</a>
          </div>
        </div>
        <div class="footer-menu">
          <div class="footer-link footer-link-bold">
            {{ $t("follow") }}
          </div>
          <div class="footer-link-social-media-wrapper mt-2">
            <div class="footer-link-social-media">
              <a :href="facebookURL" target="_blank" class="footer-social-media"
              style="font-size: 16px">
                <i class="fab fa-facebook-f"></i>
              </a>
            </div>
            <div class="footer-link-social-media">
              <a :href="instagramURL" target="_blank" class="footer-social-media">
                <i class="fab fa-instagram"></i>
              </a>
            </div>
            <div class="footer-link-social-media">
              <a :href="youtubeURL" target="_blank" class="footer-social-media">
                <i class="fab fa-youtube"></i>
              </a>
            </div>
            <div class="footer-link-social-media">
              <a :href="whatsappURL" target="_blank" class="footer-social-media">
                <i class="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="footer-menu">
          <div class="footer-link footer-link-bold">
            {{ $t("download_our_app") }}
          </div>
          <div class="footer-download">
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.paxel&amp;referrer=utm_source%3Dwebrevamp%26utm_medium%3Dbadge"
            >
              <img
                src="@/assets/images/download-play.png"
                width="160"
                height="50"
                alt="Paxel App"
                class="img-fluid mt-2"
              />
            </a>
            <span class="space-clear"></span>
            <a
              target="_blank"
              href="https://apps.apple.com/app/apple-store/id1372668166?pt=118967865&amp;ct=webrevamp&amp;mt=8"
            >
              <img
                src="@/assets/images/download-app.png"
                width="160"
                height="50"
                alt="Paxel App"
                class="img-fluid mt-2"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="footer-logo"><img src="@/assets/logo-white.svg" alt="Paxel" /></div>
      <div class="footer-copyright">© {{ new Date().getFullYear() }} Paxel </div>
    </div>
  </footer>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  name: 'Footer',
  computed: {
    revampWebURL() {
      return `${this.revampWebBaseURL}/${i18n.locale}`;
    },
  },
  data() {
    return {
      revampWebBaseURL: process.env.VUE_APP_REVAMP_WEB,
      paxelBoxURL: process.env.VUE_APP_PAXELBOX_WEB,
      paxelBigURL: process.env.VUE_APP_PAXEL_BIG_WEB,
      paxelCorporate: process.env.VUE_APP_PAXEL_CORPORATE_WEB,
      facebookURL: process.env.VUE_APP_FACEBOOK,
      instagramURL: process.env.VUE_APP_INSTAGRAM,
      youtubeURL: process.env.VUE_APP_YOUTUBE,
      whatsappURL: process.env.VUE_APP_WHATSAPP,
      paxelCekResi: process.env.VUE_APP_CEK_RESI,
      paxelCekOngkir: process.env.VUE_APP_CEK_ONGKIR,
    };
  },
};
</script>

<style scoped>
footer {
  padding: 30px 0px 15px 0px;
}
.footer-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.footer-menu {
  flex: 0 0 16.5%;
  max-width: 16.5%;
  /* margin-top: 20px; */
  margin: 0 20px 18px;
}
.footer-link {
  font-family: "GothamBook";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 24px;
  letter-spacing: normal;
  color: #ffffff;
}
.footer-link-bold {
  font-family: "GothamBold";
  font-weight: bold;
}
.footer-link > a {
  text-decoration: none;
  color: #ffffff;
}
.footer-link-social-media-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.footer-link-social-media {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 20px;
  margin-right: 5px;
  border: 2px solid #d4d4d4;
}
a.footer-social-media {
  font-size: 18px;
  color: #d4d4d4;
}
.footer-logo {
  /* padding-top: 35px;
  padding-bottom: 35px; */
  margin: 20px 20px 38px;
  display: flex;
  justify-content: flex-start;
}
.footer-copyright {
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #c4c7ca;
  margin: 20px 20px 20px;
}
.space-clear {
  display: flex;
}
@media screen and (max-width: 480px) {
  .footer-menu {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media screen and (max-width: 1024px) and (min-width: 480px) {
  .footer-menu {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media screen and (max-width: 1200px) and (min-width: 1024px) {
  .footer-menu {
    flex: 0 0 25%;
    max-width: 25%;
  }
}
</style>
